module.exports = __webpack_public_path__ + "img/toumingc.b0b308b3.png";